import { NgModule } from '@angular/core';
import { MascaraDirective } from './mascara.directive';

@NgModule({
  declarations: [MascaraDirective],
  exports: [MascaraDirective]
})
export class MascaraModule { }
